export default "__VITE_ASSET__DvKNTmvy__"